import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es un evento de ventas?',
  answer: 'No. Es una Cumbre de Inversión. El objetivo es educación de mercado y networking de alto nivel.'
}, {
  question: '¿Por qué es gratis hasta el 21 de julio?',
  answer: 'Queremos incentivar el compromiso temprano de los inversionistas más serios para garantizar un networking de calidad.'
}, {
  question: '¿El cupo es limitado?',
  answer: 'Sí. Por el formato del lugar y la calidad del networking, solo aceptaremos a un grupo selecto de asistentes registrados.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-brand-dark py-24 border-t border-white/5" data-id="element-61">
      <div className="max-w-3xl mx-auto px-6" data-id="element-62">
        <div className="text-center mb-16" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-64">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-400" data-id="element-65">
            Todo lo que necesitas saber sobre la Cumbre.
          </p>
        </div>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-gray border border-white/5 rounded-2xl overflow-hidden" data-id="element-67">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-68">
                <span className="font-semibold text-lg text-white" data-id="element-69">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-pink transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" />
              </button>

              <AnimatePresence data-id="element-71">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-72">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-73">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}